import { Button } from '@mui/material';
import ClearLessonSelectionAction from '../../../../../lessons/lessonactions/lesson-multi-selection-actions/ClearLessonSelectionAction';
import ReOrderLessonsAction from './ReOrderLessonsAction';
import { useDomain } from '../../../../../../states/AppDomainProvider';
import './TeacherCoursesRowActions.scss';
import { useTeacherCourses } from '../../../../context/TeacherCourseContextProvider';
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  onClearClick: () => { },
  selectedLessonIds: [],
  filteredLessonData: {
    lessons: [],
    included: [],
  },
};
// eslint-disable-next-line arrow-body-style
const TeacherCoursesRowActions = (p) => {
  const {
    onClearClick,
    selectedLessonIds,
    rowIndex,
    filteredLessonData,
  } = { ...defaultProps, ...filterUndefined(p) };
  const { userDomain } = useDomain();
  const { user } = userDomain.domainData;
  const { teacherCourseDomain } = useTeacherCourses();

  return (
    <div className='teacher-courses-row-actions'>
      {user.userModerator && (
        <ReOrderLessonsAction rowIndex={rowIndex} />
      )}

      <Button
        variant='contained'
        className='btn-primary'
        onClick={() => {
          const lessonIds = filteredLessonData.lessons[0].lessons.map((l) => l.id);
          teacherCourseDomain.updateSelectedLessonIds(lessonIds);
        }}
      >
        SELECT ALL
      </Button>
      <ClearLessonSelectionAction
        className='clear-selection'
        onClearClick={onClearClick}
        selectedLessonIds={selectedLessonIds}
        clearSelectedLessonTitle='Deselect activities'
      />
    </div>
  );
};

export default TeacherCoursesRowActions;
